import  { useContext, useMemo } from 'react'
import { UserDetailsContext } from '../context/userDetails'
import { getShopType } from '../utils/util';

function useShopType () {
    const {shopDomain} = useContext(UserDetailsContext);
    const shopType = useMemo(() => getShopType(shopDomain), [shopDomain]);

  return { ...shopType };
}

export default useShopType